<ui-modal [modalTitle]="mode === 'image' ? 'Select Quote Image' : 'Select Lines By Product'" size="lg" [footer]="true">

	<div *ngIf="list" class="input-group mb-2 flex-weight-1">
		<div class="input-group-prepend"><span class="input-group-text"><i class="wq wq-search"></i></span></div>
		<input type="search" class="form-control" placeholder="Search" [(ngModel)]="search" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
	</div>

	<div class="mb-2 scrollable" style="height: 500px;">
		<table *ngIf="list" class="table table-hover vam">
			<tbody>
				<tr *ngFor="let item of list | keywords:search:['sku', 'manufacturer_name', 'manufacturer_sku', 'model', 'short_description'] | pagination:pagination" [class.selectable]="mode !== 'image' || item.image_id" [ngClass]="{ 'table-success': item.selected, 'text-muted': mode === 'image' && !item.image_id }" (click)="selectItem(item)">
					<td class="shrink pr-0">
						<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
					</td>
					<td class="pl-0">
						<div *ngIf="item.short_description" class="text-bold">{{item.short_description}}</div>
						<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
						<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>
					</td>
					<td *ngIf="mode !== 'image'" class="text-right subtitle">{{item.line_count}} {{item.line_count === 1 ? 'line' : 'lines'}}</td>
					<td *ngIf="mode === 'image'" class="text-right subtitle">{{ item.image_id ? '' : 'No image' }}</td>
				</tr>
				<tr *ngIf="!pagination.count">
					<td colspan="3" class="text-secondary">No products found.</td>
				</tr>
			</tbody>
		</table>

		<div *ngIf="!list" class="w-100 h-100 d-flex align-items-center justify-content-center">
			<div class="spinner-border text-secondary"></div>
		</div>
	</div>

	<app-pagination [ngClass]="{ 'invisible': !list }" [pagination]="pagination"></app-pagination>

	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button *ngIf="selectedLines" class="btn btn-success" (click)="selectLinesButton()" ui-modal-footer>Select Lines <ui-button-badge>{{selectedLines}}</ui-button-badge></button>

</ui-modal>
